import React, { useState, useEffect } from "react";
import adminApi from '../../assets/constants/AdminRafservice.Instance';
import { connect } from 'react-redux';
import { dateTimeAdminFormatRender, anchorTagEditMode, statusToFormatRender } from '../../assets/constants/customRender'
import AdminSubHeader from '../../components/home/header/adminSubHeader';
import CardComponent from "../../components/Cards/card";
import ExpandableGridTable from "../../components/TableGrids/ExpandableGridTable.table";
import ServerSideGridTable from "../../components/TableGrids/ServerSideGridTable.table";
import Tooltip from '@mui/material/Tooltip';
import AdminSlider from '../../components/home/header/adminSlider';
import AddPermission from '../../components/Dialog/AddPermission';
import ViewPermission from '../../components/Dialog/ViewPermission';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { purple, red } from '@mui/material/colors';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

const PermissionPage = (props) => {
    const [permissionData, setGroupData] = useState([]);
    const [open, setOpen] = useState(false);
    const [viewOpen, setViewOpen] = useState(false);
    const [editPermissionData, setEditPermissionData] = useState({});

    const permissionColumn = [
        {
            name: "title",
            label: "Name",
        },
        {
            name: "description",
            label: "Description",
        },
        {
            name: "status",
            label: "Status",
            options: statusToFormatRender
        },
        {
            name: "createdAt",
            label: "Created At",
            options: dateTimeAdminFormatRender
        },
        {
            name: "updatedAt",
            label: "Updated At",
            options: dateTimeAdminFormatRender
        },
        {
            name: "id",
            label: "Action",
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <>
                            <Tooltip title="View Permission"><a className="hyperlink" style={{ cursor: "pointer" }} onClick={() => handleClickViewOpen(value)}><VisibilityIcon color="primary" /></a></Tooltip>
                            <Tooltip title="Edit Permission"><a className="hyperlink" style={{ cursor: "pointer" }} onClick={() => handleClickOpen(value)}><ModeEditOutlineIcon color="primary" /></a></Tooltip>
                            <Tooltip title="Delete Permission"><a className="hyperlink" style={{ cursor: "pointer" }} onClick={() => handleClickDelete(value)}><DeleteRoundedIcon sx={{ color: red[500] }} /></a></Tooltip>
                        </>
                    );
                }
            }
        },
    ];

    useEffect(() => {
        loadPermissionData();
    }, [
    ]);

    const handleClickViewOpen = (value) => {
        setViewOpen(true);
        editLoadPermissionData(value);
    };

    const handleViewClose = () => {
        setViewOpen(false);
        setEditPermissionData({});
    };

    const handleClickOpen = (value = '') => {
        setOpen(true);
        if (value && value != '') {
            editLoadPermissionData(value)
        } else {
            setEditPermissionData({});
        }
    };

    const handleClose = () => {
        setOpen(false);
        setEditPermissionData({});
    };

    const handleClickDelete = (value) => {
        if (value && value != '') {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this record!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                confirmBtnBsStyle: "success",
                cancelButtonText: 'No, cancel!',
                cancelBtnBsStyle: "danger",
                customClass: {
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    adminApi.delete('/permission/' + value)
                        .then(res => {
                            Swal.fire({
                                title: 'Deleted!',
                                text: 'Your record has been deleted.',
                                icon: 'success',
                                customClass: {
                                    confirmButton: 'btn btn-success',
                                    cancelButton: 'btn btn-danger',
                                }
                            })
                            loadPermissionData();
                        })
                        .catch(err => {
                            toast.error(err?.response?.data?.message);
                        })
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    Swal.fire({
                        title: 'Cancelled',
                        text: 'Your record is safe :)',
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-danger',
                            cancelButton: 'btn btn-danger',
                        }
                    })
                }
            })
        }
    };

    const editLoadPermissionData = (value) => {
        adminApi.get('/permission/' + value)
            .then(res => {
                setEditPermissionData(res.data);
            })
            .catch(err => {
                toast.error(err?.response?.data?.message);
            })
    }

    const loadPermissionData = () => {
        adminApi.get('/permission')
            .then(res => {
                setGroupData(res.data);
            })
            .catch(err => {
                toast.error(err?.response?.data?.message);
            })
    }

    return (
        <div className="container level-summary">
            <div className="row">
                <AdminSubHeader title={'Permissions'} />
                <div className='col-lg-12 pr-0 pl-0'>
                    <div className="list-member mt-4">
                        <CardComponent
                            heading={`Permissions`}
                            body={
                                <>
                                    <div>
                                        <AddPermission loadPermissionData={loadPermissionData} editPermissionData={editPermissionData} open={open} handleClickOpen={handleClickOpen} handleClose={handleClose} />
                                        <ViewPermission loadPermissionData={loadPermissionData} editPermissionData={editPermissionData} open={viewOpen} handleClickOpen={handleClickViewOpen} handleClose={handleViewClose} />
                                    </div>
                                    <ExpandableGridTable
                                        data={permissionData}
                                        columns={permissionColumn}
                                        pagination={true}
                                    ></ExpandableGridTable>
                                </>
                            }></CardComponent>
                    </div>
                </div>
            </div>
        </div>
    )
};
const mapStateToProps = (state) => {
    return {
        isSignedIn: state.auth.isSignedIn,
    };
}
export default connect(mapStateToProps)(PermissionPage);
